import { Link } from "react-router-dom";
import { images } from "@/config/images";

export default function Hero() {
  return (
    <section className="relative w-full">
      <div className="relative h-[480px] md:h-[680px] w-full overflow-hidden">
        {/* PC版背景：MEGURIロゴ（オレンジ背景） */}
        <img
          src={images.logo}
          alt="MEGURI"
          className="absolute inset-0 w-full h-full object-cover hidden md:block"
        />
        {/* スマホ版背景：自然な写真 */}
        <img
          src="https://readdy.ai/api/search-image?query=Nagasaki%20Sasebo%20mountain%20landscape%20at%20golden%20hour%20with%20wild%20boar%20theme%20in%20lush%20green%20forest%20and%20warm%20orange%20sunset%20sky%20natural%20wildlife%20photography%20style%20serene%20professional%20atmosphere%20no%20text%20cinematic%20vertical%20composition%20realistic%20nature%20photo&width=800&height=1200&seq=hero-mobile-1&orientation=portrait"
          alt="MEGURI 自然背景"
          className="absolute inset-0 w-full h-full object-cover md:hidden"
        />
        {/* 暗いオーバーレイ：スマホでは少し濃く */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/55 to-black/65 md:from-black/50 md:via-black/45 md:to-black/55"></div>

        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center text-white">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 border border-white/30 px-4 py-1.5 text-xs md:text-sm font-medium backdrop-blur-sm mb-5 md:mb-7">
            <i className="ri-leaf-line"></i>
            長崎県佐世保市のジビエ食肉加工
          </span>

          <h1 className="text-2xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight tracking-wide">
            命を、無駄なく、
            <br className="hidden md:block" />
            循環させる。
          </h1>

          <p className="mt-4 md:mt-7 text-sm md:text-base text-white/90 max-w-2xl leading-relaxed">
            女猟師が、捕獲された<strong>猪</strong>を止め刺し・血抜き・精肉まで一人で。
            <br className="hidden md:block" />
            ジビエ<strong>猪肉</strong>を、全国へお届けします。
          </p>

          <div className="mt-7 md:mt-10 flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto px-2 sm:px-0">
            <Link
              to="/purchase"
              className="inline-flex items-center justify-center gap-2 bg-background-50 text-primary-700 text-sm md:text-base font-bold px-7 py-3.5 rounded-md whitespace-nowrap transition-colors hover:bg-background-100 w-full sm:w-auto"
            >
              <i className="ri-shopping-bag-line"></i>
              商品を購入する
            </Link>
            <Link
              to="/products"
              className="inline-flex items-center justify-center gap-2 border border-white/60 text-white text-sm md:text-base font-bold px-7 py-3.5 rounded-md whitespace-nowrap transition-colors hover:bg-white/10 w-full sm:w-auto"
            >
              商品を見る
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}